<template>
  <div class="navbar" v-if="showTabContainer">
    <template v-if="isLogin">
      <div class="nav_left">
        <img src="@/assets/icon_4.png" alt="">
        <img src="@/assets/icon_5.png" alt="">
        <div class="nav_tab_box" v-if="currentPath !== '/'">
          <div v-for="(item, index) in nav_tab" :key="index" :class="{ active: currentPath === item.path }"
            @click="handleGoPath(item.path)">
            {{ t(item.label) }}
          </div>
        </div>
      </div>


      <div class="nav_right">
        <img class="lang_icon" :src="langIcon" alt="" @click="toggleLang">
        <el-dropdown @command="handleCommand">
          <span class="userbox">
            <div>
              <img :src="userimg" alt="" />
            </div>
            {{ username }}
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="4">{{ t('nav.personalInfo') }}</el-dropdown-item>
              <el-dropdown-item command="1">{{ t('nav.report') }}</el-dropdown-item>
              <!-- <el-dropdown-item command="7">{{ t('nav.accountRecharge') }}</el-dropdown-item> -->
              <el-dropdown-item command="6">{{ t('nav.feedback') }}</el-dropdown-item>
              <el-dropdown-item command="2">{{ t('nav.agreement') }}</el-dropdown-item>
              <el-dropdown-item command="3">{{ t('nav.aboutUs') }}</el-dropdown-item>
              <el-dropdown-item command="5">{{ t('common.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </template>
    <template v-else>
      <span style="flex: 1 0;"></span>
      <img class="lang_icon" :src="langIcon" alt="" @click="toggleLang">
      <span class="not_login" @click="handleGoLogin">{{ t('common.pleaseLogin') }}</span>
    </template>
  </div>


  <el-dialog v-model="protocolVisible" width="80%" top="1vh" :before-close="handleProtocolDialogClose">
    <div v-html="protocolContent"></div>
  </el-dialog>

  <PaymentDialog v-model="paymentDialogVisible" @completed="handlePaymentCompleted" />

  <FeedbackDialog v-model="feedbackDialogVisible" />

</template>

<script setup>
import { ElMessage } from 'element-plus';
import { computed, reactive, ref, getCurrentInstance, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from "@/utils/request";
import router from '@/router';
import store from '@/store';
import { ElMessageBox } from 'element-plus';
import { setLocale } from '@/locales';
import PaymentDialog from '@/components/PaymentDialog.vue';
import FeedbackDialog from '@/components/FeedbackDialog.vue';

import langCnImg from '@/assets/lang-cn.png';
import langEnImg from '@/assets/lang-en.png';


const props = defineProps({
  showTabContainer: {
    type: Boolean,
    default: true,
  }
})

const { t, locale } = useI18n();

const langIcon = computed(() => locale.value === 'zh-CN' ? langCnImg : langEnImg);

const toggleLang = () => {
  const newLocale = locale.value === 'zh-CN' ? 'en-US' : 'zh-CN';
  setLocale(newLocale);
  if (['/case','/report'].includes(currentPath.value)) {
    window.location.reload();
  }
};

const isLogin = computed(() => store.getters.isLogin);
const username = computed(() => store.state.username);
const userimg = computed(() => store.state.userInfo.img);
const currentPath = ref('/');

const nav_tab = reactive([
  {
    name: '首页',
    label: 'nav.home',
    path: '/home',
  },
  {
    name: '我是医生',
    label: 'nav.doctor',
    path: '/doctor',
  },
  {
    name: '我是患者',
    label: 'nav.patient',
    path: '/patient',
  },
  {
    name: '病例库',
    label: 'nav.case',
    path: '/case',
  }
])

watch(() => router.currentRoute.value, (e) => {
  console.log(e.name, '路由变化');
  currentPath.value = e.path;

  const parent = getCurrentInstance()?.parent?.proxy;
  if (parent && typeof parent.showTabs === 'function') {
    parent.showTabs(e.path !== '/');
  }
}, { immediate: true })

const handleGoPath = (path) => {
  router.push(path);
  const parent = getCurrentInstance()?.parent?.proxy;
  if (parent && typeof parent.showTabs === 'function') {
    parent.showTabs(path !== '/');
  }
}

const handleCommand = (command) => {
  console.log(command, '下拉菜单');
  switch (command) {
    case '1':
      console.log('正畸报告');
      router.push('/report');
      break;
    case '2':
      console.log('使用协议');
      getProtocolContent('/api/xieyi/')
      break;
    case '3':
      console.log('关于我们');
      getProtocolContent('/api/guanyuwomen/')
      break;
    case '4':
      console.log('个人信息');
      router.push('/info');
      break;
    case '6':
      console.log('意见反馈');
      feedbackDialogVisible.value = true;
      break;
    case '7':
      console.log('账户充值');
      paymentDialogVisible.value = true;
      break;
    case '5':
      ElMessageBox.confirm(t('common.confirmLogout'), t('common.tip'), {
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      }).then(() => {
        store.dispatch('logout').then(() => {
          router.replace('/home');
          ElMessage.success(t('common.logoutSuccess'));
        });
      }).catch(() => {
      });
      break;
    default:
      break;
  }
}


const handleGoLogin = () => {
  router.push('/login');
}

const paymentDialogVisible = ref(false);
const feedbackDialogVisible = ref(false);
const handlePaymentCompleted = () => {
  ElMessage.success(t('payment.checkPayment'));
}

const protocolVisible = ref(false);
const protocolContent = ref('');
const getProtocolContent = (url) => {
  axios.get(url).then(res => {
    console.log(res, '使用协议');
    protocolContent.value = res.results.text;
    protocolVisible.value = true;
  }, err => {
    console.log(err, '使用协议失败');
  })
}
const handleProtocolDialogClose = () => {
  protocolVisible.value = false;
  protocolContent.value = '';
}

</script>

<style scoped lang="scss">
.navbar {
  width: 100vw;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 70px 0 30px;

  .nav_left {
    display: flex;
    align-items: center;

    >img:nth-child(1) {
      width: 36px;
      height: 26px;
      margin-right: 10px;
    }

    >img:nth-child(2) {
      height: 21px;
      object-fit: contain;
    }

    .nav_tab_box {
      display: flex;
      align-items: center;
      column-gap: 40px;
      padding: 0 40px;

      div {
        text-align: center;
        cursor: pointer;
        user-select: none;
        position: relative;
        transition: all 0.3s ease;
      }

      div:hover {
        color: #409eff;
      }

      div.active {
        color: #409eff;
        font-weight: bold;
      }

      div.active::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 3px;
        background-color: #409eff;
        border-radius: 2px;
      }
    }
  }

  .lang_icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .nav_right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .userbox {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    cursor: pointer;
    outline: none;

    div {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 10px;
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }
  }

  .not_login {
    font-size: 16px;
    color: #333333;
    line-height: 60px;
    cursor: pointer;
    user-select: none;
    margin-left: 10px;
  }
}
</style>
